export enum BtnLoaderSize {
  MD = '32',
  RG = '24',
  SM = '16',
  XS = '12',
  XXS = '8',
  XXXS = '6'
}
